export enum StripeElementType {
  CARD = 'card',
  CARD_NUMBER = 'cardNumber',
  CARD_EXPIRY = 'cardExpiry',
  CARD_CVC = 'cardCvc',
  POSTAL_CODE = 'postalCode'
}
